var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticStyle: { "padding-top": "30px" } }, [
    _c("div", { staticClass: "page-titles p-3 border-bottom" }, [
      _c("h3", { staticClass: "text-themecolor" }, [
        _vm._v("Limited Partners\n            "),
        _vm.investor.name
          ? _c("span", { staticClass: "card-subtitle" }, [
              _vm._v(
                _vm._s(_vm.investor.name) +
                  " (" +
                  _vm._s(_vm.investor.cp_email) +
                  ")"
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-info btn-sm pull-right",
            on: {
              click: function ($event) {
                return _vm.$router.push("/account/investors")
              },
            },
          },
          [
            _c("i", { staticClass: "fas fa-list" }),
            _vm._v(" "),
            _c("span", { staticClass: "d-none d-sm-inline" }, [
              _vm._v(_vm._s(_vm.trans("investor.investor_list"))),
            ]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid p-0",
        staticStyle: { "font-size": "0.75em" },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 col-sm-12" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body p-4" }, [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("investor-sidebar", {
                      attrs: { menu: "data-matching", id: _vm.id },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-9 col-sm-9" }, [
                      _c("h4", { staticClass: "card-title" }, [
                        _vm._v("Data matching"),
                      ]),
                      _vm._v(" "),
                      _vm.transcripts.total
                        ? _c("div", { staticClass: "table-responsive" }, [
                            _c("table", { staticClass: "table table-hover" }, [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", { attrs: { scope: "col" } }, [
                                    _vm._v(
                                      _vm._s(_vm.trans("transcript.held_at"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { attrs: { scope: "col" } }, [
                                    _vm._v(
                                      _vm._s(_vm.trans("transcript.title"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("th", { attrs: { scope: "col" } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.trans("transcript.participants")
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "th",
                                    {
                                      staticClass: "table-option",
                                      attrs: { scope: "col" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.trans("general.action"))
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(
                                  _vm.transcripts.data,
                                  function (transcript) {
                                    return _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            "white-space": "nowrap",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("momentDateTime")(
                                                transcript.held_at
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("td", {
                                        domProps: {
                                          textContent: _vm._s(transcript.title),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("td", {
                                        staticClass:
                                          "pta-transcript-participants",
                                        staticStyle: { "max-width": "500px" },
                                        domProps: {
                                          innerHTML: _vm._s(
                                            transcript.speakers
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "table-option" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "btn-group" },
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName: "v-tooltip",
                                                      value: _vm.trans(
                                                        "transcript.view_meeting_minutes"
                                                      ),
                                                      expression:
                                                        "trans('transcript.view_meeting_minutes')",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "btn btn-info btn-sm",
                                                  attrs: {
                                                    to: `/account/transcripts/${transcript.id}/meeting-minutes`,
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa-light fa-screen-users",
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "router-link",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName: "v-tooltip",
                                                      value: "Data",
                                                      expression: "'Data'",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "btn btn-info btn-sm",
                                                  attrs: {
                                                    to: `/account/transcripts/${transcript.id}`,
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa-light fa-scroll",
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ]),
                          ])
                        : _c("p", [
                            _vm._v("No Transcripts for matching available."),
                          ]),
                    ]),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }